import allocationStore from 'modules/offer/stores/allocation'
import publisherStore from 'modules/offer/stores/publisher'

import BaseReportStore from './base-store'

export default new class PingCheckReport extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'ping-check'

  publisher = this.attachEntity(publisherStore, { params: { report: false } })
  allocation = this.attachEntity(allocationStore, { labelKey: 'description', params: { report: false } })
  get data() {
    return this.collection.data
  }
}
